import React from 'react';
import styled from 'styled-components';

import DateTimeInput from '../DateTimeInput';

import Bracket from './Bracket';
import Divider from './Divider';
import Delete from './Delete';
import Terminal from './Terminal';

const operators = [
  {value: 'datetime_after', label: 'is after'},
  {value: 'datetime_before', label: 'is before'},
  {value: 'datetime_equal', label: 'is on'},
  {value: 'time_after', label: 'is after time of day'},
  {value: 'time_before', label: 'is before time of day'},
  {value: 'time_equal', label: 'is on time of day'}
];

function DateCompareExpression({variables, operator, value, onChange, onCollapse}) {
  // Only allow the user to select DATETIME variables.
  const dateTimeVariables = Object.keys(variables)
    .filter(key => variables[key].type === 'DATETIME')
    .reduce((map, key) => {
      map[key] = variables[key];
      return map;
    }, {});

  return (
    <Bracket onCollapse={onCollapse}>
      <Terminal
        removable={false}
        variables={dateTimeVariables}
        value={value[0]}
        onChange={nextValue => onChange({[operator]: [nextValue, value[1]]})}
      />
      <Divider />
      <ComparisonSelector
        variables={variables}
        value={operator}
        onChange={nextOperator => onChange({[nextOperator]: value})}
      />
      <Delete onClick={() => onChange(null)} />
      <Divider />
      {(() => {
        switch(operator) {
          case 'datetime_before':
          case 'datetime_after':
          case 'datetime_equal':
            return (
              <DateTerminal
                value={value[1]}
                onChange={nextValue => onChange({[operator]: [value[0], nextValue]})}
              />
            );
          default:
            return (
              <TimeTerminal
                value={value[1]}
                onChange={nextValue => onChange({[operator]: [value[0], nextValue]})}
              />
            );
        }
      })()}
    </Bracket>
  );
}

function ComparisonSelector({value, onChange}) {
  return (
    <select value={value} onChange={e => onChange(e.target.value)}>
      {operators.map(operator => (
        <option key={operator.value} value={operator.value}>
          {operator.label}
        </option>
      ))}
    </select>
  );
}

function DateTerminal({value, onChange}) {
  const date = value && normalizeDate(value);

  return (
    <>
      <InlineDateTimeInput
        utc
        date={date}
        onChange={date => onChange(toDateOffsetExpression(date))}
      />
      <Delete onClick={() => onChange(null)} />
    </>
  );
}

function TimeTerminal({value, onChange}) {
  const date = value && normalizeDate(value);

  return (
    <>
      <InlineDateTimeInput
        utc
        timeOnly
        date={date}
        onChange={date => onChange(toDateOffsetExpression(date))}
      />
      <Delete onClick={() => onChange(null)} />
    </>
  );
}

const InlineDateTimeInput = styled(props => <DateTimeInput inline {...props} />)`
  width: 12rem;
`;

function toDateOffsetExpression(date) {
  return `${date.getTime() + (date.getTimezoneOffset() * 60 * 1000)},${date.getTimezoneOffset() * 60 * 1000}`;
}

function normalizeDate(input) {
  const [timestamp, offset] = input.split(',');
  return new Date(parseInt(timestamp, 10) - parseInt(offset, 10));
}

export default DateCompareExpression;
